export default __webpack_public_path__ + "static/media/131.7b1ffe08.png";